import * as Sentry from '@sentry/react'
import { createRoot } from 'react-dom/client'

import App from './App'
import { sentryOptions } from './config'
import reportWebVitals from './reportWebVitals'
import './index.css'

const originalConsoleError = console.error.bind(console)

console.error = (...args: unknown[]) => {
  const message = args
    .filter((arg): arg is string => typeof arg === 'string')
    .join(' ')

  if (message.includes('defaultProps')) return

  originalConsoleError(...args)
}

if (sentryOptions.dsn && process.env.REACT_APP_NODE_ENV === 'production') {
  Sentry.init(sentryOptions)
}

const rootElement = document.getElementById('root') as Element
const root = createRoot(rootElement)

root.render(<App />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
